import { useState, useMemo } from 'react';
import { CommandPaletteContext } from './CommandPaletteContext';
import CommandPaletteDialog from './CommandPaletteDialog';

export function CommandPaletteProvider({ children }: Readonly<{ children: React.ReactNode; }>) {
    const [isOpen, setIsOpen] = useState(false);
    const value = useMemo(() => ({ openCommandPalette: () => setIsOpen(true) }), []);

    return (
        <CommandPaletteContext.Provider value={value}>
            {children}
            <CommandPaletteDialog isOpen={isOpen} setIsOpen={setIsOpen} />
        </CommandPaletteContext.Provider>
    );
}